import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { Typography, withStyles } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
// import { Transform } from '@material-ui/icons';
// import Preparing from '../components/Preparing';

import Stack from '@mui/material/Stack';

const dummy_data = [
  {
    No: 1,
    position_kor: '회장',
    // position_eng: 'President',
    position_eng: 'Chairman of<br/>General Assembly ',
    name_kor: '백롱민',
    name_eng: 'Baek, Rong-Min',
    affiliation_kor: '서울대',
    affiliation_eng: 'Seoul National Univ.',
    pic: 'pic_1.JPG',
  },
  {
    No: 2,
    position_kor: '이사장',
    // position_eng: 'Chairman, \nBoard of Directors',
    position_eng: 'President',
    name_kor: '윤을식',
    name_eng: 'Yoon, Eul Sik',
    affiliation_kor: '고려대',
    affiliation_eng: 'Korea Univ.',
    pic: 'pic_2.jpg',
  },
  {
    No: 3,
    position_kor: '감사',
    position_eng: 'Auditor',
    name_kor: '유대현',
    name_eng: 'Lew, Dae Hyun',
    affiliation_kor: '연세대',
    affiliation_eng: 'Yonsei Univ.',
    pic: 'pic_5.jpg',
  },
  {
    No: 4,
    position_kor: '감사',
    position_eng: 'Auditor',
    name_kor: '문석호',
    name_eng: 'Moon, Suk Ho',
    affiliation_kor: '가톨릭대',
    affiliation_eng: 'The Catholic Univ. of Korea',
    pic: 'pic_6.jpg',
  },
  {
    No: 5,
    position_kor: '기획위원회',
    position_eng: 'Director,\nExecutive Committee',
    name_kor: '장학',
    name_eng: 'Chang, Hak',
    affiliation_kor: '서울대',
    affiliation_eng: 'Seoul National Univ.',
    pic: 'pic_7.jpg',
  },
  {
    No: 6,
    position_kor: '학술위원회',
    position_eng: 'Director,\nAcademic Affairs Committee',
    name_kor: '이원재',
    name_eng: 'Lee, Won Jai',
    affiliation_kor: '연세대',
    affiliation_eng: 'Yonsei Univ.',
    pic: 'pic_8.jpg',
  },
  {
    No: 7,
    position_kor: '편집위원회',
    position_eng: 'Editor-in-chief\nof APS',
    name_kor: '홍준표',
    name_eng: 'Hong, Joon Pio',
    affiliation_kor: '울산대',
    affiliation_eng: 'Univ. of Ulsan',
    pic: 'pic_9.jpg',
  },
  {
    No: 8,
    position_kor: '고시위원회',
    position_eng: 'Director,\nBoard Examination Committee',
    name_kor: '전영준',
    name_eng: 'Jun, Young Joon',
    affiliation_kor: '가톨릭대',
    affiliation_eng: 'The Catholic Univ. of Korea',
    pic: 'pic_10.jpg',
  },
  {
    No: 9,
    position_kor: '고시위원회',
    position_eng: 'Director,\nBoard Examination Committee',
    name_kor: '양정덕',
    name_eng: 'Yang, Jung Dug',
    affiliation_kor: '경북대',
    affiliation_eng: 'Kyungpook National Univ.',
    pic: 'pic_11.jpg',
  },
  {
    No: 10,
    position_kor: '수련교육위원회',
    position_eng: 'Director,\nTraining & Education Committee',
    name_kor: '최종우',
    name_eng: 'Choi, Jong Woo',
    affiliation_kor: '울산대',
    affiliation_eng: 'Univ. of Ulsan',
    pic: 'pic_12.jpg',
  },
  {
    No: 11,
    position_kor: '수련교육위원회',
    position_eng: 'Director,\nTraining & Education Committee',
    name_kor: '홍종원',
    name_eng: 'Hong, Jong Won',
    affiliation_kor: '연세대',
    affiliation_eng: 'Yonsei Univ.',
    pic: 'pic_13.jpg',
  },
  {
    No: 12,
    position_kor: '심사위원회',
    position_eng: 'Director, \nAccreditation Committee',
    name_kor: '남수봉',
    name_eng: 'Nam, Su Bong',
    affiliation_kor: '부산대',
    affiliation_eng: 'Pusan National Univ.',
    pic: 'pic_14.jpg',
  },
  {
    No: 13,
    position_kor: '법제위원회',
    position_eng: 'Director,\nRules and Bylaws',
    name_kor: '나영천',
    name_eng: 'Na, Young Cheon',
    affiliation_kor: '원광대',
    affiliation_eng: 'Wonkwang Univ.',
    pic: 'pic_15.jpg',
  },
  {
    No: 14,
    position_kor: '법제위원회',
    position_eng: 'Director,\nRules and Bylaws',
    name_kor: '김준형',
    name_eng: 'Kim, Jun Hyung',
    affiliation_kor: '계명대',
    affiliation_eng: 'Keimyung Univ.',
    pic: 'pic_16.jpg',
  },
  {
    No: 15,
    position_kor: '보험위원회',
    position_eng: 'Director,\nInsurance Affairs',
    name_kor: '김한구',
    name_eng: 'Kim, Han Koo',
    affiliation_kor: '중앙대',
    affiliation_eng: 'Chung-Ang Univ.',
    pic: 'pic_17.jpg',
  },
  {
    No: 16,
    position_kor: '보험위원회',
    position_eng: 'Director,\nInsurance Affairs',
    name_kor: '강상윤',
    name_eng: 'Kang, Sang Yoon',
    affiliation_kor: '경희대',
    affiliation_eng: 'Kyunghee Univ.',
    pic: 'pic_18.jpg',
  },
  {
    No: 17,
    position_kor: '정보통신위원회',
    position_eng: 'Director, \nInformation & Communication Committee',
    name_kor: '황재하',
    name_eng: 'Hwang, Jae Ha',
    affiliation_kor: '전남대',
    affiliation_eng: 'Chonnam Univ.',
    pic: 'pic_19.jpg',
  },
  {
    No: 18,
    position_kor: '정보통신위원회',
    position_eng: 'Director, \nInformation & Communication Committee',
    name_kor: '정성호',
    name_eng: 'Jeong, Seong Ho',
    affiliation_kor: '고려대',
    affiliation_eng: 'Korea Univ.',
    pic: 'pic_20.jpg',
  },
  {
    No: 19,
    position_kor: '국제협력위원회',
    position_eng: 'Director, \nInternational Affairs Committee',
    name_kor: '김영석',
    name_eng: 'Kim, Young Seok',
    affiliation_kor: '연세대',
    affiliation_eng: 'Yonsei Univ.',
    pic: 'pic_21.jpg',
  },
  {
    No: 20,
    position_kor: '홍보위원회',
    position_eng: 'Director,\nPublic Relations Committee',
    name_kor: '변재경',
    name_eng: 'Pyon, Jai Kyoung',
    affiliation_kor: '성균관대',
    affiliation_eng: 'Sungkyunkwan Univ.',
    pic: 'pic_22.jpg',
  },
  {
    No: 21,
    position_kor: '홍보위원회',
    position_eng: 'Director,\nPublic Relations Committee',
    name_kor: '김태곤',
    name_eng: 'Kim, Tae Gon',
    affiliation_kor: '영남대',
    affiliation_eng: 'Yeungnam Univ.',
    pic: 'pic_23.jpg',
  },
  {
    No: 22,
    position_kor: '윤리위원회',
    position_eng: 'Director, Ethics Committee',
    // name_kor: '박상현',
    // name_eng: 'Park, Sang Hyeon',
    // affiliation_kor: '세미 성형외과',
    name_kor: '고한웅',
    name_eng: 'Ko, Han Woong',
    affiliation_kor: 'Eye Beauty Plastic Surgery Clinic',
    affiliation_eng: 'Eye Beauty Plastic Surgery Clinic',
    pic: 'pic_24_2.png',
  },
  {
    No: 23,
    position_kor: '윤리위원회',
    position_eng: 'Director, Ethics Committee',
    name_kor: '김준혁',
    name_eng: 'Kim, Jun Hyuk',
    affiliation_kor: '순천향대',
    affiliation_eng: 'Soonchunhyang Univ.',
    pic: 'pic_25.jpg',
  },
  {
    No: 24,
    position_kor: '재무위원회',
    position_eng: 'Director, Finance Committee',
    name_kor: '박동하',
    name_eng: 'Park, Dong Ha',
    affiliation_kor: '아주대',
    affiliation_eng: 'Ajou Univ.',
    pic: 'pic_26.jpg',
  },
  {
    No: 25,
    position_kor: '대외협력위원회',
    position_eng: 'Director, External Affairs Committee',
    name_kor: '허찬영',
    name_eng: 'Heo, Chan Yeong',
    affiliation_kor: '서울대',
    affiliation_eng: 'Seoul National Univ.',
    pic: 'pic_27.jpg',
  },
  {
    No: 26,
    position_kor: '연구교육위원회',
    position_eng: 'Director, \nResearch & CME Committee',
    name_kor: '김석원',
    name_eng: 'Kim, Sug Won',
    affiliation_kor: '연세원주대',
    affiliation_eng: 'Yonsei Univ., Wonju College of Medicine',
    pic: 'pic_28.jpg',
  },

  // {
  //   No: 27,
  //   position_kor: '무임소',
  //   position_eng: 'Director at Large',
  //   name_kor: '동은상',
  //   name_eng: 'Dhong, Eun Sang',
  //   affiliation_kor: '고려대',
  //   affiliation_eng: 'Korea Univ.',
  //   pic: 'pic_29.jpg',
  // },
  {
    No: 27,
    position_kor: '무임소',
    position_eng: 'Director at Large',
    name_kor: 'Eom, Jin Sup',
    name_eng: 'Eom, Jin Sup',
    affiliation_kor: 'Asan Medical Center',
    affiliation_eng: 'Asan Medical Center',
    pic: 'pic_29_2.png',
  },
  // {
  //   No: 28,
  //   position_kor: '무임소',
  //   position_eng: 'Director at Large',
  //   name_kor: '강동희',
  //   name_eng: 'Kang, Dong Hee',
  //   affiliation_kor: '단국대',
  //   affiliation_eng: 'Dankook Univ.',
  //   pic: 'pic_30.png',
  // },

  {
    No: 28,
    position_kor: '무임소',
    position_eng: 'Director at Large',
    name_kor: 'Lee, Ik Jun',
    name_eng: 'Lee, Ik Jun',
    affiliation_kor: 'Viz Plastic Surgery',
    affiliation_eng: 'Viz Plastic Surgery',
    pic: 'pic_30_2.png',
  },
  // {
  //   No: 29,
  //   position_kor: '무임소',
  //   position_eng: 'Director at Large',
  //   name_kor: '윤인대',
  //   name_eng: 'Yun, In Dae',
  //   affiliation_kor: '윤&정 성형외과',
  //   affiliation_eng: 'Yoon & Jeong Plastic Surgery Clinic',
  //   pic: 'pic_31.jpg',
  // },
  // {
  //   No: 29,
  //   position_kor: '무임소',
  //   position_eng: 'Director at Large',
  //   name_kor: '반준섭',
  //   name_eng: 'Ban, Jun Sub',
  //   affiliation_kor: '올리브 성형외과',
  //   affiliation_eng: 'Olive Plastic Surgery Clinic',
  //   pic: 'pic_32.jpg',
  // },

  {
    No: 30,
    position_kor: '무임소',
    position_eng: 'Director at Large',
    // name_kor: '윤인대',
    // name_eng: 'Yun, In Dae',
    // affiliation_kor: '윤&정 성형외과',
    name_kor: '박상현',
    name_eng: 'Park, Sang Hyeon',
    affiliation_kor: 'Semi Plastic Surgery Clinic',
    affiliation_eng: 'Semi Plastic Surgery Clinic',
    pic: 'pic_31_2.png',
  },
  // {
  //   No: 31,
  //   position_kor: '무임소',
  //   position_eng: 'Director at Large',
  //   name_kor: '고한웅',
  //   name_eng: 'Ko, Han Woong',
  //   affiliation_kor: '함박눈 성형외과',
  //   affiliation_eng: 'Eye Beauty Plastic Surgery Clinic',
  //   pic: 'pic_33.jpg',
  // },
  {
    No: 31,
    position_kor: '무임소',
    position_eng: 'Director at Large',
    name_kor: 'Han, Sungbum',
    name_eng: 'Han, Sungbum',
    affiliation_kor: 'Batang Plastic Surgery',
    affiliation_eng: 'Batang Plastic Surgery',
    pic: 'pic_33_2.png',
  },
  {
    No: 32,
    position_kor: '총무',
    position_eng: 'Executive Secretary',
    name_kor: '유희진',
    name_eng: 'You, Hi Jin',
    affiliation_kor: '고려대',
    affiliation_eng: 'Korea Univ.',
    pic: 'pic_34.jpg',
  },
];

const members = [
  {
    No: 35,
    // position_eng: 'Director, Academic Affairs Committee',
    position_eng: 'Director',
    name_eng: 'Lee, Won Jai',
    affiliation_eng: 'Yonsei Univ.',
    pic: 'pic_35.PNG',
  },
  {
    No: 36,
    position_eng: 'Members',
    name_eng: 'Kang, Moon Seok',
    affiliation_eng: 'Wonjin Plastic Surgery',
    pic: 'pic_36.jpg',
  },
  {
    No: 37,
    position_eng: 'Members',
    name_eng: 'Chu Lo Shui',
    affiliation_eng: 'GokSaem Plastic Surgery Clinic',
    pic: 'pic_37.jpg',
  },
  {
    No: 38,
    position_eng: 'Members',
    name_eng: 'Kim, Ki Tae',
    affiliation_eng: 'TAE Plastic Surgery Clinic',
    pic: 'pic_38.png',
  },
  {
    No: 39,
    position_eng: 'Members',
    name_eng: 'Kim, Baek-Kyu',
    affiliation_eng: 'Seoul National Univ.',
    pic: 'pic_39.jpg',
  },
  {
    No: 40,
    position_eng: 'Members',
    name_eng: 'Kim, Byung Jun',
    affiliation_eng: 'Seoul National Univ.',
    pic: 'pic_40.jpg',
  },
  {
    No: 41,
    position_eng: 'Members',
    name_eng: 'Kim, Young Seok',
    affiliation_eng: 'Yonsei Univ.',
    pic: 'pic_21.jpg',
  },
  {
    No: 42,
    position_eng: 'Members',
    name_eng: 'Kim, Jong Seo',
    affiliation_eng: 'Kim-Jongseo Clinic',
    pic: 'pic_42.jpg',
  },
  {
    No: 43,
    position_eng: 'Members',
    name_eng: 'Moh, Jae Seong',
    affiliation_eng: 'Dr.Moh Plastic Surgery',
    pic: 'PRS_profile.png',
  },
  {
    No: 44,
    position_eng: 'Members',
    name_eng: 'Park, Sung-Wan',
    affiliation_eng: 'April31 Plastic Surgery Clinic',
    pic: 'pic_44.jpg',
  },
  {
    No: 45,
    position_eng: 'Members',
    name_eng: 'Seo, Florence Bommie',
    affiliation_eng: 'The Catholic Univ. of Korea',
    pic: 'pic_45.png',
  },
  {
    No: 46,
    position_eng: 'Members',
    name_eng: 'Suh, Hyun Suk',
    affiliation_eng: 'Univ. of Ulsan',
    pic: 'pic_46.jpg',
  },
  {
    No: 47,
    position_eng: 'Members',
    name_eng: 'Shin, Ho Seong',
    affiliation_eng: 'Soonchunhyang Univ.',
    pic: 'pic_47.png',
  },
  {
    No: 48,
    position_eng: 'Members',
    name_eng: 'Oh, Tae Suk',
    affiliation_eng: 'Univ. of Ulsan',
    pic: 'pic_48.jpg',
  },
  {
    No: 49,
    position_eng: 'Members',
    name_eng: 'Lee, Won',
    affiliation_eng: 'Yonsei E1 Plastic Surgery Clinic',
    pic: 'pic_49.png',
  },
  {
    No: 50,
    position_eng: 'Members',
    name_eng: 'Lee, Kyung Jin',
    affiliation_eng: 'Gwangmyeong Sungae Hospital',
    pic: 'pic_50.bmp',
  },
  {
    No: 51,
    position_eng: 'Members',
    name_eng: 'Lee, Young Dae',
    affiliation_eng: 'MBW Aesthetic Plastic Surgical Clinic',
    pic: 'pic_51.png',
  },
  {
    No: 52,
    position_eng: 'Members',
    name_eng: 'Lee, Jin Gyu',
    affiliation_eng: 'ABLY Plastic Surgery Clinic',
    pic: 'pic_52.png',
  },
  {
    No: 53,
    position_eng: 'Members',
    name_eng: 'Jeon, Byung-Joon',
    affiliation_eng: 'Sungkyunkwan Univ.',
    pic: 'pic_53.jpg',
  },
  {
    No: 54,
    position_eng: 'Members',
    name_eng: 'Jun, Young Joon',
    affiliation_eng: 'The Catholic Univ. of Korea',
    pic: 'pic_10.jpg',
  },
  {
    No: 55,
    position_eng: 'Members',
    name_eng: 'Jeong, Woon Hyeok',
    affiliation_eng: 'Keimyung Univ.',
    pic: 'pic_55.png',
  },

  {
    No: 56,
    position_eng: 'Members',
    name_eng: 'Choi, Dong Il',
    affiliation_eng: 'Gamgnam Seoyon Plastic Surgery Clinic',
    pic: 'pic_56.png',
  },
  {
    No: 57,
    position_eng: 'Members',
    name_eng: 'Choi, Moon Seop',
    affiliation_eng: 'GRACEONYOUNG Plastic Surgery Clinic',
    pic: 'pic_57.jpg',
  },
  {
    No: 58,
    position_eng: 'Members',
    name_eng: 'Hwang, Na Hyun',
    affiliation_eng: 'Korea Univ.',
    pic: 'pic_58.png',
  },
  {
    No: 59,
    position_eng: 'Assistant Director',
    name_eng: 'Lee, Dong Won',
    affiliation_eng: 'Yonsei Univ.',
    pic: 'pic_59.PNG',
  },
  {
    No: 60,
    position_eng: 'Assistant Director',
    name_eng: 'Beak, Wooyeol',
    affiliation_eng: 'Yonsei Univ.',
    pic: 'pic_60.PNG',
  },
];
const styles = (theme) => ({
  imgWrap: {
    borderRadius: '5px',
    width: '100%',
    height: '240px',
    overflow: 'hidden',
    alignItems: 'flex-end',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      alignItems: 'baseline',
      height: '225px',
    },
  },
});

class Committee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };
  }

  componentDidMount() {}

  render() {
    const { classes } = this.props;
    const mapToComponent = (datas, col) =>
      datas.map((data, idx) => {
        return (
          <Grid
            key={idx}
            item
            xs={col}
            style={data.No === 56 || data.No === 57 || data.No === 58 || data.No === 59 ? { marginRight: 22 } : {}}
          >
            <div>
              <Grid container justifyContent="center" className={classes.imgWrap}>
                <img
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2021/committee/${data.pic}`}
                  alt={'committee'}
                  style={
                    data.pic === 'pic_6.jpg'
                      ? { top: '50%', left: '50%', minWidth: '100%', minHeight: '100%', width: 'auto', height: 'auto' }
                      : data.pic === 'pic_9.jpg'
                      ? { width: '120%' }
                      : data.pic === 'pic_10.jpg'
                      ? {
                          top: '50%',
                          left: '50%',
                          width: '100%',
                          height: 'auto',
                        }
                      : data.pic === 'pic_13.jpg'
                      ? { width: '127%' }
                      : data.pic === 'pic_14.jpg'
                      ? { width: '100%', marginTop: '-20%' }
                      : data.pic === 'pic_15.jpg'
                      ? { width: '117%' }
                      : data.pic === 'pic_22.jpg'
                      ? { width: '111%', marginTop: '-20%' }
                      : data.pic === 'pic_24.png'
                      ? { width: '140%' }
                      : data.pic === 'pic_25.jpg'
                      ? { width: '110%', marginTop: '-18%' }
                      : data.pic === 'pic_29.jpg'
                      ? { width: '140%' }
                      : data.pic === 'pic_30.png'
                      ? { width: '120%', marginTop: '-22%' }
                      : data.pic === 'pic_35.PNG'
                      ? { width: '116%' }
                      : data.pic === 'pic_36.jpg'
                      ? { width: '120%' }
                      : data.pic === 'pic_39.jpg'
                      ? { width: '176%', marginTop: '-29%' }
                      : data.pic === 'pic_42.jpg'
                      ? { top: '50%', left: '50%', width: '150%' }
                      : data.pic === 'pic_44.jpg'
                      ? { width: '100%', marginTop: '-20%' }
                      : data.pic === 'pic_45.png'
                      ? { width: '103%' }
                      : data.pic === 'pic_46.jpg'
                      ? { width: '147%' }
                      : data.pic === 'pic_47.png'
                      ? { width: '119%' }
                      : data.pic === 'pic_48.jpg'
                      ? { width: '150%' }
                      : data.pic === 'pic_49.png'
                      ? { width: '169%', marginLeft: '-27%', marginTop: '-44%' }
                      : data.pic === 'pic_51.png'
                      ? { width: '144%', marginTop: '-28%' }
                      : data.pic === 'pic_52.png'
                      ? { width: '114%' }
                      : data.pic === 'pic_55.png' || data.pic === 'pic_31.jpg' || data.pic === 'pic_18.jpg'
                      ? { width: '121%' }
                      : data.pic === 'pic_56.png'
                      ? { width: '132%', marginLeft: '-3%' }
                      : data.pic === 'pic_57.jpg'
                      ? { width: '111%' }
                      : data.pic === 'pic_59.PNG'
                      ? { width: '106%' }
                      : data.pic === 'PRS_profile.png'
                      ? { width: '100%', height: '100%' }
                      : { width: '100%' }
                  }
                />
              </Grid>
              {/* <div
                style={{
                  color: this.props.theme.palette.primary.main,
                  fontSize: 14,
                  backgroundPosition: 'left bottom',
                  backgroundRepeat: 'repeat-x',
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                <p>{data.position_eng.split('^')[0]}</p>
                <p>{data.position_eng.split('^')[1]}</p>
              </div>
              <p style={{ color: '#555', fontSize: 16, fontWeight: 'bold', textAlign: 'center' }}>{data.name_eng}</p>
              <p style={{ color: '#aaa', fontSize: 14, textAlign: 'center' }}>{data.affiliation_eng}</p> */}

              <Stack direction={'column'}>
                <Grid container justifyContent="center" alignItems="center" style={{ height: 54, paddingTop: 8 }}>
                  <Typography
                    style={{
                      color: this.props.theme.palette.primary.main,
                      fontSize: '1.1em',
                      fontWeight: 'bold',
                      lineHeight: 1,
                      textAlign: 'center',
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.position_eng.split('^')[0],
                      }}
                    />

                    {/* {data.position_eng.split('^')[0]} */}
                    {data.position_eng.split('^')[1]}
                  </Typography>
                </Grid>
                <Grid>
                  <Typography style={{ color: '#555', fontSize: 16, fontWeight: 'bold', textAlign: 'center' }}>{data.name_eng}</Typography>
                </Grid>
                <Grid>
                  <Typography style={{ color: '#aaa', fontSize: 14, textAlign: 'center' }}>{data.affiliation_eng}</Typography>
                </Grid>
              </Stack>
            </div>
          </Grid>
        );
      });

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={0} SIdx={2} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Committee</MainTitle>
            </Grid>
            <Grid style={{ width: '1024px' }} container justifyContent="center" alignItems="center">
              <p
                style={{
                  backgroundColor: this.props.theme.palette.primary.main,
                  padding: '15px 0',
                  paddingLeft: '20px',
                  color: '#fff',
                  fontSize: '1.5em',
                  width: '100%',
                  fontWeight: 'bold',
                  backgroundImage: `url('/images/PRS2021/committee/gradient.png')`,
                  textAlign: 'center',
                }}
              >
                Board of Directors of KSPRS
              </p>
              <Grid item style={{ width: '40%' }}>
                <Grid container spacing={3} style={{ margin: '10px 0' }}>
                  {mapToComponent(dummy_data.slice(0, 4), 6)}
                </Grid>
              </Grid>

              <Grid item style={{ width: '83%' }}>
                <Grid container spacing={3} justifyContent="center" style={{ margin: '10px 0' }}>
                  {mapToComponent(dummy_data.slice(4, 28), 3)}
                </Grid>
              </Grid>

              <Grid item style={{ width: '83%' }}>
                <Grid container spacing={3} justifyContent="center" style={{ margin: '10px 0' }}>
                  {mapToComponent(dummy_data.slice(28, 31), 3)}
                </Grid>
              </Grid>

              {/* <Grid item style={{ width: '83%' }}>
                <Grid container spacing={3} style={{ margin: '10px 0' }}>
                  {mapToComponent(dummy_data.slice(4, dummy_data.length + 1), 3)}
                </Grid>
              </Grid> */}

              {/* <Grid item style={{ width: '83%' }}>
                <Grid container spacing={3} style={{ margin: '10px 0' }}>
                  {mapToComponent(dummy_data.slice(4, dummy_data.length + 1), 3)}
                </Grid>
              </Grid> */}
              <p
                style={{
                  backgroundColor: '#008000',
                  padding: '15px 0',
                  paddingLeft: '20px',
                  color: '#fff',
                  fontSize: '1.5em',
                  width: '100%',
                  fontWeight: 'bold',
                  backgroundImage: `url('/images/PRS2021/committee/gradient.png')`,
                  textAlign: 'center',
                }}
              >
                Members, Academic Affairs Committee
              </p>

              <Grid item style={{ width: '40%' }}>
                <Grid container spacing={3} justifyContent="center" style={{ margin: '10px 0' }}>
                  {mapToComponent(members.slice(0, 1), 6)}
                </Grid>
              </Grid>
              <Grid item style={{ width: '83%' }}>
                <Grid container spacing={3} justifyContent="center" style={{ margin: '10px 0' }}>
                  {mapToComponent(members.slice(1, 21), 3)}
                </Grid>
              </Grid>
              <Grid item style={{ width: '83%' }}>
                <Grid container justifyContent="center" style={{ margin: '10px 0' }}>
                  {mapToComponent(members.slice(21, 24), 3)}
                </Grid>
                <Grid container justifyContent="center" style={{ margin: '10px 0' }}>
                  {mapToComponent(members.slice(24, 27), 3)}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Committee);
